import React from 'react';
import { defineMessages, FormattedMessage, 
    // intlShape, 
    injectIntl } from 'react-intl';
import { Input, Icon } from "@chakra-ui/react";
import CustomModal from '../../containers/custom-modal.jsx';
import './drawerComponents.css';
import bindAll from 'lodash.bindall';
import wifiTop from '../../lib/assets/icon--wifiConnect.svg';
import warnIcon from './icon--warn.svg';
import modalWifi from '../assets/modalWifi.png'
import errorTip from './errorTip.png'
import wifiConnectIcon from './wifiConnectIcon.png'
import {message} from 'antd';

const messages = defineMessages({
    camNousTitle: {
        defaultMessage: 'Please connect NOUS to the same wireless network as this device',
        description: 'Please connect NOUS to the same wireless network as this device',
        id: 'gui.homePage.camNousTitle'
    },
    camNousWifiName: {
        defaultMessage: 'Please enter a WiFi name (only supports the 2.4g frequency band)',
        description: 'Please enter a WiFi name (only supports the 2.4g frequency band)',
        id: 'gui.homePage.camNousWifiName'
    },
    camNousWifiPassword: {
        defaultMessage: 'Please enter your WiFi password',
        description: 'Please enter your WiFi password',
        id: 'gui.homePage.camNousWifiPassword'
    },
    camNousWifiTip: {
        defaultMessage: 'The prompt only supports Wi Fi in the 2.4G frequency band. This service will not record your Wi Fi messages and passwords',
        description: 'The prompt only supports Wi Fi in the 2.4G frequency band. This service will not record your Wi Fi messages and passwords',
        id: 'gui.homePage.camNousWifiTip'
    },
    camNousWifiConnect: {
        defaultMessage: 'connect',
        description: 'connect',
        id: 'gui.homePage.camNousWifiConnect'
    },
    camNousWifiConnectError: {
        defaultMessage: 'Please enter the correct WiFi account and password',
        description: 'Please enter the correct WiFi account and password',
        id: 'gui.homePage.camNousWifiConnectError'
    }
});

// wifi连接

class WifiConnectModal extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
            'handleChange',
            'getOkClick'
        ]);
        this.state = {
            ssid: '',
            password: '',
            status: true,
            error: false,
            showLoading: false,
            url: ''
        }
    }

    componentDidMount() {
        if(!this.state.ssid || !this.state.password) {
            this.setState({
                status: false
            }) 
        }
    }
    handleChange (event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
        if(this.state.ssid && this.state.password) {
            this.setState({
                status: true
            })
        }
    }
    getOkClick() {
        if (!this.state.ssid || !this.state.password) {
            message.error(this.props.intl.formatMessage(messages.camNousWifiConnectError));
            return;
        }
        this.props.onChildData('loading');
        if (this.state.ssid && this.state.password) {
            this.setState({
                status: false,
                showLoading: true
            })
            window.peripheral.connectWiFi(this.state.ssid, this.state.password).then(r => {
                console.log(r, '连接wifi返回参数')
                if (r == 0) {
                    window.peripheral.cameraStart().then(i => {
                        console.log(i, 'ip')
                        const pattern = /^(\d{1,3}\.){3}\d{1,3}$/
                        if (i && pattern.test(i)) {
                            this.setState({
                                url: i,
                                status: true,
                                showLoading: false
                            })
                            this.props.onChildData('success', i);
                        } else {
                            this.props.onChildData('error');
                            message.error(this.props.intl.formatMessage(messages.ErrorVideoIp));
                            this.setState({
                                showLoading: false
                            })
                            return;
                        }
                    })
                } else {
                    // this.setState({
                    //     error: true,
                    //     status: false,
                    //     showLoading: false
                    // })
                    this.props.onChildData('error');
                }
            })
            .catch(reason => {
                // this.setState({
                //     status: false,
                //     showLoading: false
                // })
                this.props.onChildData('error');
                console.log(reason);
            });
        } else {
            this.setState({
                status: false,
                // showLoading: true
            })
            this.props.onChildData('error');
        }
    }
    render() {
        const { intl, ...props } = this.props;
        const { ssid, password, status, error, showLoading } = this.state;
        return (
            <div>
                <CustomModal
                    className="modalContent"
                    id="wifiConnectModal"
                    contentLabel={intl.formatMessage(messages.camNousTitle)}
                    hasHeaderLine={false}
                    headerImageTop={modalWifi}
                    onRequestClose={this.props.onCloseModal}
                    showCloseBtn={true}
                >
                    <div className="wifiConnectInput">
                        <Input
                            required
                            className="ssidInput"
                            name="ssid"
                            // placeholder={this.props.intl.formatMessage(
                            //     messages.otaSsid
                            // )}
                            placeholder={intl.formatMessage(messages.camNousWifiName)}
                            type="text"
                            value={ssid}
                            autoComplete="off"
                            onChange={this.handleChange}

                        />
                        <br/>
                        {/* 处理浏览器 密码填充问题 */}
                        <Input
                            readOnly
                            type="password"
                            style={{ position: 'absolute', left: '-2000px', opacity: 0, display: 'none' }}
                        />
                        <Input
                            required
                            className="passwordInput"
                            name="password"
                            placeholder={intl.formatMessage(messages.camNousWifiPassword)}
                            type="password"
                            autoComplete="new-password"
                            // onFocus="this.type='password'"
                            value={password}
                            onChange={this.handleChange}
                        />
                        {error ? <div className="otaErrorwifi">
                            <img
                                className="otaWarningIcon"
                                src={warnIcon}
                            />
                            {this.props.intl.formatMessage(
                                messages.otaWifiError
                            )}
                        </div> : <div />}
                        <div className="wifiTips">
                            <img src={errorTip} />
                            <span className="wifiTipsTitle">{intl.formatMessage(messages.camNousWifiTip)}</span>
                        </div>
                        <div className="footer">
                            <div className={!ssid || !password || !showLoading ? "okBtn" : "okBtnDis"} onClick={this.getOkClick}>
                            { showLoading ?
                                <Icon type="loading" style={{margin: '5px'}} /> : null}
                                {/* 确定 */}
                                {intl.formatMessage(messages.camNousWifiConnect)}
                            </div>
                            {/* 取消 */}
                            {/* <div className="cancelBtn" onClick={this.props.onCloseModal}>
                                <FormattedMessage
                                    defaultMessage="Cancel"
                                    id="gui.modal.cancel"
                                />
                            </div> */}
                        </div>
                    </div>
                </CustomModal>
            </div>
        );
    }
}
WifiConnectModal.propTypes = {
    // intl: intlShape
};

export default injectIntl(WifiConnectModal);
